module.exports = __webpack_public_path__ + "img/logo.e61c5a74.jpg";